// D3: a reference picked under the composer or added through "+" travels with the message; the bubble shows it by its label.
export type ChatAttachment = {
  readonly kind: 'concept' | 'template' | 'upload' | 'link'
  readonly id: string
  readonly name: string
  readonly label: string
  readonly image?: string | null
}

export type ChatAttachOption = { readonly value: string; readonly label: string }

export type ChatReferenceCard = { readonly name: string; readonly kind: string; readonly image?: string | null }

export const withAttachment = (attachment: ChatAttachment | null, text: string) =>
  attachment ? `[${attachment.label} · ${attachment.name}] ${text}` : text
